<template>
  <Fragment>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="空间和品牌产品维度统计" name="first">
        <template v-if="$route.name !== 'areaAndProductTj'">
          <router-view></router-view>
        </template>
        <section class="container" v-else>
          <Breadcrumb />
          <div class="card-wrap mt-20 mb-20">
            <section class="card-content">
              <div class="left">
                <div class="search-name mr-20">
                  <span>省：</span>
                  <el-select
                    v-model="provinceId"
                    clearable
                    placeholder="请选择"
                    @change="getCityOptions(provinceId)"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="search-name mr-20">
                  <span>市：</span>
                  <el-select v-model="cityId" clearable placeholder="请选择">
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.areaId"
                      :label="item.areaName"
                      :value="item.areaId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="search-name mr-20">
                  <span>品牌：</span>
                  <el-select
                    v-model="brandCode"
                    clearable
                    placeholder="请选择"
                    @change="getTypeOptions"
                  >
                    <el-option
                      v-for="item in brandTypeOptions"
                      :key="item.brandCode"
                      :label="item.brandName"
                      :value="item.brandCode"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="search-name mr-20">
                  <span>类型：</span>
                  <el-select v-model="typeCode" clearable placeholder="请选择">
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.typeCode"
                      :label="item.typeName"
                      :value="item.typeCode"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-button
                  type="primary"
                  class="ml-20"
                  @click="searchAreaAndProductInfo"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  class="mr-20"
                  @click="exportAreaAndProductTJ"
                  >下载</el-button
                >
              </div>
            </section>
          </div>
          <div class="card-wrap mt-20 mb-20">
            <span style="font-weight:bold">拍码总数：{{ sumNum }}</span>
          </div>
          <el-table :data="list" style="width: 150%" border>
            <el-table-column label="序号" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="省" width="250">
              <template slot-scope="scope">
                <span>{{ scope.row.provinceName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="市" width="250">
              <template slot-scope="scope">
                <span>{{ scope.row.cityName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="品牌" width="250">
              <template slot-scope="scope">
                <span>{{ scope.row.brandName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="分类" width="350">
              <template slot-scope="scope">
                <span>{{ scope.row.typeName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="拍码数">
              <template slot-scope="scope">
                <span>{{ scope.row.number }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20 pagination"
            background
            layout="total,prev, pager, next, jumper"
            :total="total"
            :page-size="10"
            :current-page="pageNum"
            @prev-click="handlePrePage"
            @next-click="handleNextPage"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </section>
      </el-tab-pane>
      <el-tab-pane label="空间和品牌产品维度统计图表" name="second">
        <div class="card-wrap mt-20 mb-40">
          <span
            style="font-size:25px;font-weight:bold;text-align: center;display:block;color: darkblue"
            >空间和品牌产品维度统计统计表 拍码数：{{ sumNum }}
          </span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      activeName: "first",
      sumNum: "",
      brandTypeOptions: [],
      typeOptions: [],
      provinceOptions: [],
      cityOptions: [],
      brandCode: "",
      typeCode: "",
      provinceId: "",
      cityId: "",
      areaId: "",
      areaName: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getAreaAndProductList() {
      let _this = this;
      let param = {
        url:
          "/api/productNewTJAreaAndProduct/getProductNewTjAreaAndProductPage",
        params: {
          provinceId: _this.provinceId,
          cityId: _this.cityId,
          brandCode: _this.brandCode,
          typeCode: _this.typeCode,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getAreaAndProductList", param).then(() => {
        _this.list = _this.$store.state.shootTJ.areaAndProductList.list;
        _this.total = _this.$store.state.shootTJ.areaAndProductList.total;
        if (_this.list.length > 0) {
          _this.sumNum = _this.list[0].sumNum;
        } else {
          _this.sumNum = 0;
        }
      });
    },
    //查询
    searchAreaAndProductInfo() {
      let _this = this;
      _this.getAreaAndProductList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getAreaAndProductList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getAreaAndProductList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getAreaAndProductList();
    },
    //下载
    exportAreaAndProductTJ() {
      let _this = this;
      let param = {
        provinceId: _this.provinceId,
        cityId: _this.cityId,
        brandCode: _this.brandCode,
        typeCode: _this.typeCode
      };
      _this.$Api
        .post(
          "/api/productNewTJAreaAndProduct/exportProductNewTjAreaAndProduct",
          param
        )
        .then(response => {
          if (response.status === 200) {
            _this.$Api.exportExcel(
              ["拍码总数", "省", "市", "品牌", "分类", "拍码数"],
              [
                "sumNum",
                "provinceName",
                "cityName",
                "brandName",
                "typeName",
                "number"
              ],
              response.data,
              "NewProducts_AreaAndProductTj"
            );
          } else {
            _this.$message({
              message: "无法获取导出数据",
              type: "warning"
            });
          }
        });
    },
    //省下拉获取
    getProvinceOptions() {
      let _this = this;
      let param = {
        url: "/api/dictionaryArea/getDictionaryAreaList",
        params: {
          areaId: _this.areaId
        }
      };

      _this.$store.dispatch("getProvinceOptions", param).then(() => {
        _this.provinceOptions = _this.$store.state.area.provinceOptions;
      });
    },
    //根据省下拉获取对应的市
    getCityOptions(value) {
      let _this = this;
      let param = {
        url: "/api/dictionaryArea/getDictionaryAreaList",
        params: {
          areaId: value
        }
      };

      _this.$store.dispatch("getCityOptions", param).then(() => {
        _this.cityOptions = _this.$store.state.area.cityOptions;
      });
    },
    //获取品牌下拉
    getBrandTypeOptions() {
      let _this = this;
      let param = {
        url: "/api/brand/getAllBrandInfo"
      };

      _this.$store.dispatch("getBrandTypeOptions", param).then(() => {
        _this.brandTypeOptions = _this.$store.state.brandType.brandTypeOptions;
      });
    },
    //根据品牌下拉获取对应的类型
    getTypeOptions() {
      //   let _this = this;
      //   let param = {
      //    // url: "/api/dictionaryArea/getDictionaryAreaList",
      //     params: {
      //       brandCode: this.brandCode
      //     }
      //   };
      //   _this.$Api.loading();
      //   _this.$store
      //     .dispatch("getCityOptions", param)
      //     .then(() => {
      //       _this.$Api.close();
      //       _this.typeOptions = _this.$store.state.area.typeOptions;
      //     })
      //     .catch(_this["$Api"].close());
    }
  },
  created() {
    let _this = this;
    _this.getAreaAndProductList();
    //品牌下拉框
    _this.getBrandTypeOptions();
    //省下拉框
    _this.getProvinceOptions();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
